import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
const
  animations = {
    draggableGallery: async () => await import('./../animations/draggable-gallery'),
    scaleElWidth: async () => await import('./../animations/scale-element-width'),
    revealTextByLine: () => import('./../animations/reveal-text-by-line'),
    revealButtonOnYScroll: () => import('./../animations/reveal-button-on-y-scroll')
  },
  draggables = document.querySelectorAll('.gallery-draggable'),
  toScaleWidthElements = document.querySelectorAll('.scale-width > div'),
  toRevealTexts = document.querySelectorAll('.text-reveal'),
  newsSection = document.querySelectorAll('.news-block-home'),
  newsletterBtn = document.querySelector('.newsletter--call .btn-hidden'),
  textBtn = document.querySelector('.new--text-button'),
  helpers = {
    smoothScrollTo: () => import('./../helpers/smooth-scroll-to'),
  },
  services = {
    Video: () => import('./../services/video-controller')
  }

export const homepage = () => {
  if (draggables.length > 0) {
    for (const [index, draggable] of draggables.entries()) {
      const draggableContainer = draggable.querySelector('.gallery-draggable__container');
      animations.draggableGallery().then(module => module.draggableGallery(draggable, draggableContainer, index))
    }
  }

  if (toScaleWidthElements.length > 0) {
    animations.scaleElWidth().then(module => {
      for (const element of toScaleWidthElements) {
        const cover = element.querySelector('.scale-width__cover')
        const isIntro = element.getAttribute("data-scale") === "intro" ? true : false
        module.scaleWidth(element, cover ? cover : null, isIntro ? "top " + element.parentNode.offsetTop : "top 80%", !isIntro)
      }
    })
  }

  if (toRevealTexts.length > 0) {
    animations.revealTextByLine().then(module => {
      for (const text of toRevealTexts) {
        module.revealTextByLine(text)
      }
    })
  }

  if (newsSection.length > 0) {
    for (const section of newsSection) {
      const hiddenButtons = section.querySelectorAll('.btn-hidden')

      if(hiddenButtons.length > 0) {
        for(const button of hiddenButtons) {
          animations.revealButtonOnYScroll().then(module => module.revealButtonOnYScroll(button))
        }
      }
    }
  }

  if(newsletterBtn) {
    animations.revealButtonOnYScroll().then(module => module.revealButtonOnYScroll(newsletterBtn))
  }
   if(textBtn) {
    animations.revealButtonOnYScroll().then(module => module.revealButtonOnYScroll(textBtn))
  }
  
  $(".video-home-block a").click(function(e){
    var href = $(this).attr("href");
    if(href.startsWith("#")) {
      e.preventDefault();
      var offset = 0;
      if($(href+" > div").length) {
        var paddingTop = parseInt($(href+" > div").first().css('padding-top'));
        offset = (paddingTop/3)*2;
        console.log(offset);
      }
      
      helpers.smoothScrollTo().then(module => {
          module.smoothScrollTo(href,1200,offset);
        })
    }
  });

  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function () {

      const homeTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: '#sticky-check',
          scroller: '.smooth-scroll',
          start: 'top top',
          end: 'bottom+=500',
          scrub: true,
          pin: true,
          fastScrollEnd: true
        }
      })

      homeTimeline
        .add('start')
        .to('.bg-op', {
          opacity: 1,
          duration: 3
        }, 'start')
        .to('.sticky-home.sticky-white', {
          yPercent: 50,
          top: "50%",
          duration: 3
        }, 'start')
        .to('.stiky-home-1', {
          yPercent: -50,
          top: "calc(50% - 160px)",
          duration: 3
        }, 'start')
        .to('.video-home-block', {
          y: -($(".sticky-home").height() + 250), //+250
          duration: 3
        }, 'start')
    }
  })
  //if($(".yacht__video-full").attr("data-vimeo"))
  services.Video().then(module => module.VideoInit());
}
